export enum LineItemStatus {
  Active = 'Active',
  Updated = 'Updated',
  Cancelled = 'Cancelled',
  Returned = 'Returned',
  FullyReturned = 'FullyReturned',
  Delete = 'Delete',
  New = 'New',
  Utilized = 'Utilized',
}
